"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasBoxPrintableGroup;
function hasBoxPrintableGroup(printableGroups) {
  return !!printableGroups.find(pg => pg.type === 'wooden-box');
}